import { render, staticRenderFns } from "./proemployeeworkcenter.vue?vue&type=template&id=b9a36588&scoped=true&"
import script from "./proemployeeworkcenter.vue?vue&type=script&lang=js&"
export * from "./proemployeeworkcenter.vue?vue&type=script&lang=js&"
import style0 from "./proemployeeworkcenter.vue?vue&type=style&index=0&id=b9a36588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a36588",
  null
  
)

export default component.exports